import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "flex h-9 w-9 cursor-pointer items-center justify-center border border-solid border-white bg-transparent backdrop-blur" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_biz_icon = _resolveComponent("biz-icon")!
  const _component_BizTooltip = _resolveComponent("BizTooltip")!

  return (_ctx.type === 'icon' && _ctx.isAiGenerated)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(_ctx.iconContainerClasses)
      }, [
        _createVNode(_component_BizTooltip, {
          text: _ctx.tooltipText,
          position: _ctx.tooltipPosition,
          "trigger-type": "auto"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_biz_icon, {
                name: "ai-icon",
                class: _normalizeClass(`${_ctx.iconSize} ${_ctx.iconColor} `)
              }, null, 8, ["class"])
            ])
          ]),
          _: 1
        }, 8, ["text", "position"])
      ], 2))
    : (_ctx.type === 'label' && _ctx.isAiGenerated)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(_ctx.labelClasses)
        }, [
          _createVNode(_component_biz_icon, {
            name: "ai-icon",
            class: _normalizeClass(`${_ctx.iconSize} ${_ctx.iconColor} `)
          }, null, 8, ["class"]),
          _createElementVNode("span", {
            class: _normalizeClass(`${_ctx.textColor}`)
          }, _toDisplayString(_ctx.text), 3)
        ], 2))
      : _createCommentVNode("", true)
}